import { Text } from "@nulogy/components";
import React from "react";
import styled from "styled-components";

const BreakWordWrap = styled(Text)`
  overflow-wrap: break-word;
`;

export default function TruncatedTextTooltip({ label }) {
  return (
    <BreakWordWrap fontSize="smaller" fontWeight="normal">
      {label}
    </BreakWordWrap>
  );
}
